import { gql } from '@apollo/client';
import checkpointReappraisalRationaleReviewFragment from './checkpointReappraisalRationaleReviewFragment';

const GET_CHECKPOINT_REAPPRAISAL_RATIONALE_REVIEW = gql`
  query GetCheckpointReappraisalRationale($checkPointId: Int!) {
    checkPointReappraisalRationaleReview(checkPointId: $checkPointId) {
      ...CheckpointReappraisalRationaleReviewFields
    }
  }
  ${checkpointReappraisalRationaleReviewFragment}
`;

export default GET_CHECKPOINT_REAPPRAISAL_RATIONALE_REVIEW;
